// Ensures that type 'T' does indeed contain the key 'name' of type 'string'
export function getKey<T>(name: Extract<keyof T, string>) {
  return name;
}
